<div class="container mt-3">
  <div class="card shadow">
    <div class="card-header">
      <h5 class="mb-0">Create New Planogram</h5>
    </div>
    <div class="card-body">
      <form [formGroup]="planogramForm" (ngSubmit)="onSubmit()">

        <!-- Mode Selection -->
        <div class="mb-3">
          <label class="form-label">Creation Mode</label>
          <div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="modeDataLoad" value="dataload" formControlName="mode">
              <label class="form-check-label" for="modeDataLoad">Use Data Load</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="modePSA" value="psa" formControlName="mode">
              <label class="form-check-label" for="modePSA">Import from PSA</label>
            </div>
          </div>
        </div>

        <!-- Store -->
        <div class="mb-3">
          <label class="form-label">Store <span class="text-danger">*</span></label>
          <input type="text" class="form-control"
            [ngbTypeahead]="searchStores"
            [inputFormatter]="storeInputFormatter"
            [resultFormatter]="storeResultFormatter"
            (selectItem)="onStoreSelected($event)"
            (input)="storeSearchTerm.next($any($event.target).value)"
            placeholder="Search store..."
            [class.is-invalid]="planogramForm.get('store')?.invalid && planogramForm.get('store')?.touched" />
        </div>

        <!-- Merchandise -->
        <div class="mb-3">
          <label class="form-label">Merchandise <span class="text-danger">*</span></label>
          <input type="text" class="form-control"
            [ngbTypeahead]="searchMerch"
            [inputFormatter]="merchInputFormatter"
            [resultFormatter]="merchResultFormatter"
            (selectItem)="onMerchSelected($event)"
            (input)="merchSearchTerm.next($any($event.target).value)"
            placeholder="Search merchandise..."
            [class.is-invalid]="planogramForm.get('merchandise')?.invalid && planogramForm.get('merchandise')?.touched" />
        </div>

        <!-- Data Load or PSA -->
        <ng-container *ngIf="!isPsaImport; else psaSection">
          <div class="mb-3">
            <label class="form-label">Data Load <span class="text-danger">*</span></label>
            <select class="form-select" formControlName="dataLoadGuid"
              [disabled]="isLoadingDataLoads"
              [class.is-invalid]="planogramForm.get('dataLoadGuid')?.invalid && planogramForm.get('dataLoadGuid')?.touched">
              <option value="">-- Select Data Load --</option>
              <ng-container *ngIf="dataLoads$ | async as dataLoads">
                <option *ngFor="let dl of dataLoads" [value]="dl.dataLoadGuid">
                  [{{ RangeType[dl.rangeTypeId] }}] {{ dl.dataLoadTime | date:'medium' }}
                </option>
              </ng-container>
            </select>
          </div>
        </ng-container>

        <ng-template #psaSection>
          <div class="mb-3">
            <label class="form-label">PSA File <span class="text-danger">*</span></label>
            <input class="form-control" type="file" accept=".psa"
              (change)="onFileSelected($event)"
              [class.is-invalid]="planogramForm.get('psaFile')?.invalid && planogramForm.get('psaFile')?.touched">
          </div>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Sales Period Start <span class="text-danger">*</span></label>
              <input type="date" class="form-control" formControlName="salesStart"
                [class.is-invalid]="planogramForm.get('salesStart')?.invalid && planogramForm.get('salesStart')?.touched">
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Sales Period End <span class="text-danger">*</span></label>
              <input type="date" class="form-control" formControlName="salesEnd"
                [class.is-invalid]="planogramForm.get('salesEnd')?.invalid && planogramForm.get('salesEnd')?.touched">
            </div>
          </div>
          <div class="form-check form-switch mb-3">
            <input class="form-check-input" type="checkbox" id="usePsaProductData" formControlName="usePsaProductData">
            <label class="form-check-label" for="usePsaProductData">
              Use product data from PSA file
            </label>
          </div>
        </ng-template>

        <!-- Folder -->
        <div class="mb-3">
          <label class="form-label">Parent Folder (optional)</label>
          <select class="form-select" formControlName="folderId" [disabled]="isLoadingFolders">
            <option value="">-- Default Folder --</option>
            <ng-container *ngIf="availableFolders$ | async as folders">
              <option *ngFor="let f of folders" [value]="f.id">{{ f.name }}</option>
            </ng-container>
          </select>
        </div>

        <!-- Buttons -->
        <div class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="isSubmitting || planogramForm.invalid">
            <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-1"></span>
            Create Planogram
          </button>
        </div>

      </form>
    </div>
  </div>
</div>